import { render, staticRenderFns } from "./registerSuccessThree.vue?vue&type=template&id=3b1d8206&scoped=true&"
import script from "./registerSuccessThree.vue?vue&type=script&lang=js&"
export * from "./registerSuccessThree.vue?vue&type=script&lang=js&"
import style0 from "./registerSuccessThree.vue?vue&type=style&index=0&id=3b1d8206&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1d8206",
  null
  
)

export default component.exports